import { authEnv, cognitoConfig } from './authEnvConstants'

function trimTrailingSlash(url: string): string {
  return url.replace(/\/+$/, '')
}

function withLeadingSlash(value: string): string {
  return value.startsWith('/') ? value : `/${value}`
}

export function getAuthAppUrl(): string {
  if (typeof window !== 'undefined') {
    return trimTrailingSlash(window.location.origin)
  }

  if (authEnv.appUrl) {
    return trimTrailingSlash(authEnv.appUrl)
  }

  throw new Error('NEXT_PUBLIC_APP_URL is not set')
}

export function getCognitoBaseUrl(): string {
  if (!cognitoConfig.baseUrl) {
    throw new Error(
      'Cognito base URL is not set: define NEXT_PUBLIC_COGNITO_BASE_URL or NEXT_PUBLIC_COGNITO_DOMAIN',
    )
  }

  return trimTrailingSlash(cognitoConfig.baseUrl)
}

export function getAuthApiBaseUrl(): string {
  if (!authEnv.authApiUrl) {
    throw new Error('NEXT_PUBLIC_AUTH_URL is not set')
  }

  return trimTrailingSlash(authEnv.authApiUrl)
}

export function getApiGatewayBaseUrl(): string {
  if (!authEnv.apiGatewayUrl) {
    throw new Error('NEXT_PUBLIC_API_GATEWAY_URL is not set')
  }

  const stage = authEnv.apiGatewayStage
    ? withLeadingSlash(authEnv.apiGatewayStage)
    : process.env.NODE_ENV === 'production'
      ? '/prod'
      : '/dev'

  return `${authEnv.apiGatewayUrl.replace(/\/+$/, '')}${stage}`
}

export const AUTH_ROUTE_PATHS = {
  /** Client route that redirects the browser to `{NEXT_PUBLIC_AUTH_URL}/google` (not a backend path). */
  googleSsoEntry: '/auth/google',
  authCallback: '/auth/callback',
  googleCallback: '/google/callback',
} as const

export const AUTH_URLS = {
  get googleSSOStart() {
    return `${getAuthApiBaseUrl()}/google`
  },
  get googleCallback() {
    return `${getAuthAppUrl()}${AUTH_ROUTE_PATHS.googleCallback}`
  },
  get postLogoutRedirect() {
    return getAuthAppUrl()
  },
  get cognitoLogout() {
    return `${getCognitoBaseUrl()}/logout`
  },
} as const
